import { OPTIONS } from '@/components/Layout/Menu/HeaderV2/components/NewAiHeaderButton/NewAiHeaderButton.types';
import {
  IconMail,
  IconPicture,
  IconSearch,
  IconSites,
  IconStarMoving,
  IconDashboard,
  IconSupport,
  IconMenu,
  IconAdd,
  IconAiPencil,
  IconClock,
  IconGlobeCursor,
  IconServer,
  IconBag,
  IconTools,
} from 'gatorcomponents';
import React from 'react';
import step2Br from '@/media/guide/AiGuide/step2_br.png';
import step3Br from '@/media/guide/AiGuide/step3_br.png';

export default {
  welcome: name => (
    <div>
      <span>
        {`Olá ${name}, `}
      </span>
      O que você quer que eu faça hoje?
    </div>
  ),
  suggestions: 'Tenho algumas sugestões pra você:',
  options: [
    {
      icon: IconPicture,
      label: 'Criar um novo site',
      initialMessage: 'Me ajude a criar um novo site',
      action: 'newSite',
    },
    {
      icon: IconSites,
      label: 'Configurar meu domínio',
      initialMessage: 'Configure o meu domínio',
      action: 'domainConfig',
    },
    {
      icon: IconMail,
      label: 'Criar um e-mail profissional',
      initialMessage: 'Me ajude a criar um e-mail profissional',
      action: 'email',
    },
    {
      icon: IconSearch,
      label: 'Resolver pendências',
      action: 'openAlerts',
    },
  ],
  askMaiaPlaceholder: 'Converse com o Gator...',
  genericLoadingMessage: 'Analisando a melhor forma de ajudar...',
  name: 'Gator',
  tag: 'Beta',
  tooltips: {
    alerts: 'Resolver pendências',
    minify: 'Minimizar',
    close: 'Fechar',
    shrink: 'Diminuir',
    fullScreen: 'Tela cheia',
    settings: 'Configurações',
    closeDocument: 'Fechar documento',
    closeAlerts: 'Fechar pendências',
    delete: 'Deletar',
    cantDelete: alertTitle => `Não é possível deletar a pendência "${alertTitle}"`,
    delay: 'Lembrar mais tarde',
    copyText: 'Copiar Texto',
    likeAnswer: 'Gostei da resposta',
    dislikeAnswer: 'Precisa Melhorar',
  },
  popover: {
    groupOptions: 'Opções',
    groupSettings: 'Opções',
    groupUseful: 'Links úteis',
    close: 'Fechar chat do Gator',
    sidebar: 'Mudar chat para tela lateral',
    settings: 'Configurações',
  },
  loadingMessages: {
    default: 'Analisando...',
  },
  marketingPlanTitle: 'Plano de marketing',
  sitePreview: 'Prévia do Site',
  showMaiaOnInit: 'Abrir o Gator automaticamente',
  audioRecording: {
    recordingLabel: 'Ouvindo...',
    transcribingLabel: 'Gerando Transcrição...',
  },
  ratingSurveyLabel: 'O Gator está sempre aprendendo e pode cometer erros. Revise as respostas. ',
  whatAiCouldDo: 'Confira tudo que eu posso fazer por você',
  viewFullImage: 'Ampliar imagem',
  headerLocale: {
    options: [
      {
        label: 'Criar site',
        value: OPTIONS.CREATE_SITE,
        message: 'Me ajude a criar um novo site',
        Icon: IconDashboard,
      },
      {
        label: 'Criar e-mail',
        value: OPTIONS.CREATE_EMAIL,
        message: 'Me ajude a criar um e-mail profissional',
        Icon: IconMail,
      },
      {
        label: 'Marketing',
        value: OPTIONS.MARKETING_TIPS,
        message: 'Liste as formas em que você pode me ajudar com marketing',
        Icon: IconStarMoving,
        websocketType: 'multi-agent',
      },
      {
        label: 'Suporte',
        value: OPTIONS.SUPPORT,
        message: 'Preciso de suporte',
        Icon: IconSupport,
      },
      {
        label: 'Mais',
        value: OPTIONS.MORE,
        message: 'Quais outras coisas você pode me ajudar?',
        Icon: IconMenu,
      },
      {
        label: 'Contratar domínio',
        value: OPTIONS.DOMAIN_PURCHASE,
        message: 'Quero contratar um domínio',
        showMoreOptions: true,
        Icon: IconAdd,
      },
      {
        label: 'Configurar domínio (DNS)',
        value: OPTIONS.CONFIGURE_DOMAIN,
        message: 'Configure o meu domínio',
        showMoreOptions: true,
        Icon: IconSites,
      },
      {
        label: 'Checar minha conta',
        value: OPTIONS.CHECK_ACCOUNT,
        message: 'Faça um diagnóstico da minha conta',
        showMoreOptions: true,
        Icon: IconTools,
      },
      {
        label: 'Criar posts',
        value: OPTIONS.CREATE_POSTS,
        message: 'Me ajude a criar mensagens para posts nas redes sociais.',
        showMoreOptions: true,
        Icon: IconAiPencil,
      },
      {
        label: 'Contratar produto',
        value: OPTIONS.CONTRACT_PRODUCT,
        message: 'Quero contratar um novo produto',
        showMoreOptions: true,
        Icon: IconBag,
      },
    ],
    actions: 'Ações',
    talkToMaia: 'Pergunte ou peça ao Gator para fazer alguma coisa...',
    talkToMaiaMobile: 'Converse com o Gator...',
    alreadyOpened: 'Você já tem um chat aberto com o Gator',
    recordingLabel: 'Ouvindo...',
    transcribingLabel: 'Gerando Transcrição...',
  },
  ratingSurveyCta: 'Como foi usar o Gator?',
  whatAiCouldDoMessage: 'Como você pode me ajudar?',
  privacyPolicy: 'Política de privacidade',
  termsOfUse: 'Termos de uso',
  homeGuideLocale: {
    steps: [
      {
        img: 'developStep1',
        salute: name => `Olá, ${name}. Estou aqui para te ajudar!`,
        title: 'Oi! Eu sou o Gator, seu novo agente de IA.',
        description: 'Tô aqui para criar seu site, configurar e-mail ou domínio. Criar conteúdos e muito mais. Conta comigo pro que você precisar!',
      },
      {
        img: step2Br,
        title: 'Pode deixar comigo!',
        description: 'Posso configurar seu domínio, criar e-mails, instalar o WordPress. É só me contar o que precisa ou escolher um dos atalhos aqui do lado.',
      },
      {
        img: step3Br,
        title: 'Estou presente em todo Portal do Cliente',
        description: 'Pode me encontrar no topo de qualquer página do portal. É só digitar ou falar comigo.',
      },
    ],
    currentStep: ({ current, total }) => `${current + 1} de ${total}`,
    nextCta: 'Próximo',
    gotItCta: 'Entendi',
  },
  alerts: {
    title: 'Pendências',
    emptyTitle: 'Sem pendências no momento',
    emptyDescription: 'Quando surgirem novas pendências, você poderá resolvê-las com a ajuda do Gator.',
    defaultGatorMessage: 'Confira ao lado as pendências dos seus produtos e escolha uma delas para que eu te ajude a avançar em seus objetivos.',
    'website-not-created': {
      title: 'Crie seu site agora',
      Icon: IconDashboard,
      description: 'Coloque sua ideia no ar em minutos e comece a atrair clientes.',
      createSiteOptionLabel: 'Quero criar site para o domínio: ',
      actionLabel: 'Criar Site',
      htmlMessage: '<p>Escolha abaixo em qual domínio deseja criar o seu site: </p>',
      severity: 'warning',
    },
    'domain-not-configured': {
      Icon: IconSites,
      title: 'Domínio não configurado',
      description: 'Seu domínio já está registrado, mas ainda não foi conectado ao site.',
      configureDomainOptionLabel: 'Me ajude a configurar meu domínio: ',
      actionLabel: 'Configurar',
      htmlMessage: '<p>Abaixo estão listados os seus domínios que ainda não estão configurados. Escolha um dos domínios para continuar: </p>',
      severity: 'critical',
    },
    createEmail: {
      title: 'E-mail profissional não criado',
      Icon: IconMail,
      description: 'Um endereço @seudomínio transmite mais credibilidade. Criar agora?',
      actionLabel: 'Criar E-mail',
      severity: 'critical',
    },
    temporaryDomain: {
      id: 'temporary-domain',
      Icon: IconClock,
      title: ({ days = 7 }) => `Domínio temporário em uso há ${days} dias`,
      description: 'Configure já um domínio próprio e dê mais credibilidade ao seu negócio.',
      actionLabel: 'Configurar',
      severity: 'warning',
    },
    validateDomain: {
      id: 'validate-domain',
      Icon: IconGlobeCursor,
      title: 'Valide seu domínio internacional',
      description: 'Confirme sua compra para evitar bloqueios ou a perda do domínio.',
      actionLabel: 'Confirmar',
      severity: 'critical',
    },
    serverCapacity: {
      id: 'server-capacity',
      Icon: IconServer,
      title: 'Seu servidor atingiu 80% da capacidade de arquivos.',
      description: 'Organize seus conteúdos agora para evitar bloqueios no seu site.',
      actionLabel: 'Gerenciar',
      severity: 'critical',
    },
    toast: {
      successDelay: 'Ok! Te avisaremos sobre essa pendência em outro momento.',
      successDelete: 'Pendência deletada.',
      notAllowed: ({ list, amount }) => `Atenção: A${amount > 1 ? 's' : ''} pendência${amount > 1 ? 's' : ''} ${list} não pode${amount > 1 ? 'm' : ''} ser deletada${amount > 1 ? 's' : ''}.`,
      undoCta: 'Desfazer',
    },
  },
  surveyLocale: {
    titleScore: 'Escolha um emoji que diga tudo sobre sua experiência com o Gator',
    titleFeedback: 'O que você gostou e não gostou no Gator?',
    titleFinished: 'Com sua avalição o Gator vai ficar cada vez melhor. Obrigado!',
    textareaPlaceholder: 'Conte sobre sua experiência',
    emojiBad: 'Ruim',
    emojiGood: 'Amei',
    closeCta: 'Fechar',
    continueCta: 'Continuar',
  },
  alertsCta: {
    label: (
      <>
        {'Você tem '}
        <strong>pendências</strong>
      </>
    ),
    cta: 'Resolver agora',
    ctaSolve: 'Resolver pendências',
  },
  beforeLeaveModal: {
    title: 'Você está a um passo de alcançar mais pessoas',
    description:
        'Se sair agora, vai precisar recomeçar. Continue e deixe o Agente de marketing turbinar seus posts para o seu perfil alcançar seus objetivos mais rápido.',
    continueLabel: 'Continuar',
    cancelLabel: 'Sair e excluir',
  },
};
